<template>
  <div id="demo">
    <div class="content_box">
      <div class="inner">
        <RegisterFormContainer class="mx-auto" :title="$t('openDemoAdditAcc.header')">
          <AccountCreationResult
            :account="`${userInfo.accNum}`"
            :server="userInfo.server"
            :downloadType="`mt${userInfo.platform}`"
          />
        </RegisterFormContainer>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet_demo_accs } from '@/resource';
import AccountCreationResult from '@/components/register/AccountCreationResult.vue';
import RegisterFormContainer from '@/components/register/registerForms/RegisterFormContainer.vue';

export default {
  name: 'Demo',
  components: { AccountCreationResult, RegisterFormContainer },
  data() {
    return {
      urls: this.$config.getMetaTraderLinks(this.$store.state.common.regulator),
      userInfo: {}
    };
  },
  mounted() {
    apiGet_demo_accs().then(resp => {
      console.log(resp);
      if (resp.data.code == 0) {
        this.userInfo = { ...resp.data.data[0] };
      }
    });
  }
};
</script>
